<template>
  <div class="module pageContainer">
    <div style="text-align: right">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-row :gutter="20">
            <el-col :span="6" style="padding-top: 10px">时间：</el-col>
            <el-col :span="18">
              <el-date-picker
                v-model="dateValue"
                :clearable="false"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="search('date')"
              >
              </el-date-picker>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7">
          <el-row :gutter="20">
            <el-col :span="6" style="padding-top: 10px">称呼：</el-col>
            <el-col :span="28">
              <el-select
                v-model="nameValue"
                @change="search('name')"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in nameList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row :gutter="20">
            <el-col :span="6" style="padding-top: 10px">手机号：</el-col>
            <el-col :span="18">
              <el-select
                v-model="phoneValue"
                @change="search('phone')"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in phoneList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="search()">搜索</el-button>
          <el-button @click="reset()">重置</el-button>
        </el-col>
      </el-row>
    </div>
    <div></div>
    <div class="resultArea u-border">
      <div class="tableList">
        <div style="display: flex; margin-bottom: 16px; font-size: 16px">
          <div>总PV:{{ totalPV }}</div>
          <div style="margin-left: 16px">今日：{{ todayPV }}</div>
          <div style="margin-left: 32px">总UV：{{ totalUV }}</div>
          <div style="margin-left: 16px">今日：{{ todayUV }}</div>
        </div>
        <el-table
          empty-text="抱歉，暂无相关数据"
          style="width: 100%"
          v-loading="tableLoad"
          :data="tableData"
        >
          <el-table-column
            type="index"
            label="序号"
            width="150"
          ></el-table-column>
          <el-table-column prop="gen_time" label="提交时间"></el-table-column>
          <el-table-column prop="name" label="称呼"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
        </el-table>
        <div style="width: 100%; text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getcustomerList } from "../../../api/customerReq";
import { getcustomerName } from "../../../api/customerReq";
import { getcustomerPhone } from "../../../api/customerReq";
export default {
  name: "customer",
  inject: ["myMessage"],
  data() {
    return {
      tableLoad: false,
      tableData: [],
      dateValue: null,
      nameValue: null,
      phoneValue: null,
      totalPV: 0,
      todayPV: 0,
      totalUV: 0,
      todayUV: 0,
      page: 1,
      limit: 10,
      where: [],
      total: 0,
      phoneList: [],
      nameList: [],
    };
  },
  methods: {
    handleSizeChange(val) {
      this.limit=val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page=val;
      this.search();
    },
    search(name = null) {
      this.where = [];
      let start_time = null;
      let end_time = null;
      switch (name) {
        case "date":
          if (this.dateValue.length) {
            start_time = moment(this.dateValue[0]).format("YYYY-MM-DD");
            end_time = moment(this.dateValue[1]).format("YYYY-MM-DD");
          }
          break;
        case "name":
          break;
        case "phone":
          break;
      }
      if (start_time) {
        this.where.push(["gen_time", ">=", start_time+' '+'00:00:00']);
        this.where.push(["gen_time", "<=", end_time+' '+ '23:59:59']);
      }
      if (this.nameValue) {
        this.where.push(["name", "=", this.nameValue]);
      }
      if (this.phoneValue) {
        this.where.push(["phone", "=", this.phoneValue]);
      }
      const data = {
        limit: this.limit,
        page: this.page,
        where: this.where,
      };
      getcustomerList(data)
        .then((res) => {
          this.tableData = res.datalist;
          this.tableLoad = false;
          this.totalPV = res.total_pv;
          this.totalUV = res.total_uv;
          this.todayUV = res.today_uv;
          this.todayPV = res.today_pv;
          this.total = res.count;
        })
        .catch(() => {
          this.myMessage.megError("查询失败,请重试");
        });
    },
    reset() {
      this.dateValue = null;
      this.nameValue = null;
      this.phoneValue = null;
      this.search();
    },
  },
  created() {
    this.search();
    getcustomerName().then((res) => {
      this.nameList = res.data;
    });
    getcustomerPhone().then((res) => {
      this.phoneList = res.data;
    });
  },
};
</script>

<style>
</style>
